import { theme } from "../../layout";
import { ActivityIndicator } from "../ActivityIndicator";
import { Title3 } from "../Typography";
import { styles } from "./styles";
import { ButtonProps, ButtonType } from "./types";

export const Button = ({
  title,
  onClick,
  type = ButtonType.Primary,
  loading,
  disabled,
}: ButtonProps) => {
  const disabledStyle = disabled ? styles.disabled : undefined;

  const buttonStyle =
    type === ButtonType.Primary ? styles.buttonPrimary : styles.buttonSecondary;

  const textStyle =
    type === ButtonType.Primary ? styles.textPrimary : styles.textSecondary;

  return (
    <div
      onClick={onClick}
      style={{ ...styles.container, ...buttonStyle, ...disabledStyle }}
    >
      {loading ? (
        <div style={styles.loader}>
          <ActivityIndicator color={theme.loader.inverse} />
        </div>
      ) : (
        <Title3 style={textStyle}>{title}</Title3>
      )}
    </div>
  );
};
